module.exports = __webpack_public_path__ + "static/media/covid-iq800w.5e3fdb13.png";